import React from 'react';
import Reveal from './Reveal';

const FORMATS = ['Vendor-native robot code', 'Deploy packs with provenance', 'Safety-zone proposals', 'STEP bundles', 'DXF floor plans', 'XLSX factory docs', 'AutomationML', 'Program clips for review'];

const DeploySection = () => (
  <section id="deploy" className="py-28 bg-white dark:bg-black border-t border-black/10 dark:border-white/10">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <div className="font-mono text-xs tracking-[0.25em] uppercase text-emerald-600 dark:text-emerald-400 mb-4">05 — Deploy & handoff</div>
        <h2 className="text-4xl sm:text-5xl md:text-6xl font-bold tracking-tight text-gray-900 dark:text-white mb-6 max-w-3xl">
          Files your floor already recognizes
        </h2>
        <p className="text-lg sm:text-xl text-gray-600 dark:text-gray-400 max-w-2xl mb-12">
          The formats your integrator, PLC engineer, and ops lead already use —
          with full provenance: what was verified, at what tier, against what.
          Your PLC and safety engineer stay in charge.
        </p>
        <div className="flex flex-wrap gap-3">
          {FORMATS.map((f) => (
            <span
              key={f}
              className="font-mono text-xs sm:text-sm px-4 py-2.5 rounded-full border border-black/15 dark:border-white/15 text-gray-700 dark:text-gray-300 bg-black/[0.03] dark:bg-white/[0.03]"
            >
              {f}
            </span>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);

export default DeploySection;
